import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BadgesComponent } from '../badges/badges.component';

@Component({
  selector: 'app-shipping-tooltip',
  templateUrl: './shipping-tooltip.component.html',
  styleUrls: ['./shipping-tooltip.component.scss'],
  imports: [CommonModule, BadgesComponent],
})
export class ShippingTooltipComponent {
  @Input()
  type: string = '';
  @Input()
  shippingHeading = {
    status: {
      status_type: 'white',
      track: '1 Day late',
    },
  };

  @Input()
  shipping: any = [
    {
      label: 'Order date',
      status: {
        status_type: 'white',
        date: 'June 24, 2023',
      },
    },
    {
      label: 'Packed',
      status: {
        status_type: 'completed',
        date: 'June 24, 2023',
      },
    },
    {
      label: 'Dispatched',
      status: {
        status_type: 'cancelled',
        date: 'June 26, 2023',
      },
    },
    {
      label: 'Delivered',
      status: {
        status_type: 'cancelled',
        date: 'June 26, 2023',
      },
    },
  ];
}
